import { PayloadAction } from "@reduxjs/toolkit";
import { Middleware, MiddlewareAPI, Dispatch } from "redux";

import { IActionMeta, ProcessingType } from "./createAction";

type ProcessingTypeKeys = keyof typeof ProcessingType;

export type ActionProcessingConfigType = {
  [x in ProcessingTypeKeys]: (dispatch: Dispatch) => void;
};

export const createActionProcessingMiddleware = (config: ActionProcessingConfigType): Middleware => {
  return ({ dispatch }: MiddlewareAPI) => next => (action: PayloadAction<any, string, { actionProcessing: IActionMeta }>) => {
    const meta = action.meta;
    if (meta && meta.actionProcessing) {
      if (ProcessingType.ClearNotification === (meta.actionProcessing.processingType & ProcessingType.ClearNotification)) {
        const dispatchingAction = config[ProcessingType[ProcessingType.ClearNotification]];
        if (dispatchingAction) {
          dispatchingAction(dispatch);
        }
      }
    }

    return next(action);
  };
};
